/* eslint-disable jsx-a11y/alt-text */
import config from "./config";
import { Roles } from "./helper";

const { admin, bank, vendor, superAdmin } = Roles;

const { routes } = config;

const links = [
  {
    authorizedUsers: [superAdmin, admin, bank, vendor],
    name: "Dashboard",
    url: routes.dashboard,
    id: 0,
  },
  {
    authorizedUsers: [superAdmin, admin, bank, vendor],
    name: "Pending Jobs",
    url: routes.pendingJobs,
    id: 4,
  },
  {
    authorizedUsers: [bank, vendor, admin, superAdmin],
    name: "Pending Acknowledgment",
    url: routes.pendingAcknowledgment,
    id: 6,
  },
  {
    authorizedUsers: [bank, vendor, admin, superAdmin],
    name: "Rejected Jobs",
    url: routes.rejectedJobs,
    id: 7,
  },
  {
    authorizedUsers: ["all"],
    name: "Awaiting Payment",
    url: routes.awaitingPayments,
    id: 10,
  },
  {
    authorizedUsers: [bank, admin, superAdmin],
    name: "Closed Jobs",
    url: routes.closedJobs,
    id: 8,
  },
  {
    authorizedUsers: [bank, admin, superAdmin],
    name: "Awaiting Solicitors Assignment",
    url: routes.awaitingVendorAssignment,
    id: 1,
  },
  {
    authorizedUsers: [admin, superAdmin],
    name: "Manual Reassignment",
    url: routes.manualReassignment,
    id: 5,
  },
  {
    authorizedUsers: [bank, admin, superAdmin],
    name: "Awaiting Confirmation",
    url: routes.awaitingBranchConfirmation,
    id: 9,
  },
  {
    authorizedUsers: [admin, superAdmin],
    name: "Paid Jobs",
    url: routes.paidJobs,
    id: 11,
  },
  {
    authorizedUsers: [admin, superAdmin, bank],
    name: "Reports",
    url: routes.reports,
    id: 12,
  },
  {
    authorizedUsers: [admin, superAdmin],
    name: "Registered Employees",
    url: routes.registeredEmployees,
    id: 3,
  },
  {
    authorizedUsers: [admin, superAdmin],
    name: "Registered Solicitors",
    url: routes.registeredVendor,
    id: 2,
  },
];

export default links;
